import React, { createContext, useState } from 'react';

// Creamos el contexto para el modo oscuro
export const DisplaySettingsContext = createContext({});

const DisplaySettingsProvider = ({ children }) => {

  const getCookie = (name) => {
    var cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
        }
    }
    return null;
  };

  const setCookie = (name, value) => {
    let domain = window.location.hostname;
    const domainSplit = domain.split('.');
    domain = domainSplit[0]
    let dateActual = new Date();
    dateActual.setFullYear(dateActual.getFullYear() + 5);
    document.cookie = `${name}=${value}; domain=${domain}.com; expires=${dateActual.toUTCString()}; path=/`
}

  // Estado para controlar el modo oscuro
  const [darkMode, setDarkMode] = useState(() => {
    // Obtener el valor del modo oscuro del Local Storage, o predeterminado a true si no existe
    const storedDarkMode = getCookie('dark_mode')
    return (storedDarkMode === 'true');
  });

  const [fontSizeSetting , setFontSizeSetting] = useState(()=>{
    return parseInt(getCookie('font_size') || 0)
  })

  // Función para cambiar el modo oscuro
  const toggleDarkMode = () => {
    setDarkMode(prevMode => {
      const newMode = !prevMode;
      setCookie('dark_mode',newMode)
      return newMode;
  });
  };



  // Pasamos el estado y la función de cambio como valor del proveedor
  return (
    <DisplaySettingsContext.Provider value={{ darkMode, toggleDarkMode, fontSizeSetting, setFontSizeSetting }}>
      {children}
    </DisplaySettingsContext.Provider>
  );
};

export default DisplaySettingsProvider;